import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { Breadcrumb, Row, Col } from 'antd';

import Spin from 'components/Spin';
import { Space } from 'v2/components/Shared/Space';
import TopPage from 'v2/components/Shared/TopPage';
import eduzzAccountsService from 'v2/services/eduzzAccount';

export default function ZapierNew() {
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const [betaModules] = useObservable(() => eduzzAccountsService.getBetaModules(), []);
  if (!user || !Array.isArray(betaModules)) return null;
  if (!betaModules.includes('zapier')) return <Redirect to='/producer/dashboard' />;
  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <strong>Zapier</strong>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to='/producer/zapier'>Minhas Integrações</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Nova integração</Breadcrumb.Item>
        </Breadcrumb>
        <Space axis='vertical' size={16} />
        <TopPage title='Criar Nova Integração' />
      </Col>
      <Col span={24}>
        <React.Suspense fallback={<Spin />}>
          <zapier-app-directory
            app='eduzz'
            link-target='new-tab'
            theme='light'
            introcopy='hide'
            create-without-template='hide'
            use-this-zap='show'
          />
        </React.Suspense>
      </Col>
    </Row>
  );
}
